module.exports = __webpack_public_path__ + "img/share.5bf4aa04.png";